module.exports = __webpack_public_path__ + "static/media/teachers-logo--no-text.9e8fd35d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/teachers-logo--no-text.svg
// module id = 578
// module chunks = 0